/* Lifestyle navigation events. No cookies, identifiers, queues or extra trackers. */
(() => {
  'use strict';
  const events = new Set(['dw_home_product_click', 'dw_home_collection_click']);
  const placements = new Set(['hero', 'companion', 'scene', 'selection', 'styling']);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-dw-event]') : null;
    if (!link || !link.closest('[data-dw-lifestyle-home]')) return;
    const name = link.dataset.dwEvent;
    const placement = link.dataset.dwPlacement;
    if (!events.has(name) || !placements.has(placement)) return;
    const shopify = window.Shopify;
    if (!shopify || shopify.designMode || !shopify.customerPrivacy || !shopify.analytics) return;
    try {
      const privacy = shopify.customerPrivacy;
      if (privacy.analyticsProcessingAllowed() !== true || privacy.currentVisitorConsent().analytics !== 'yes') return;
      const payload = { placement, design: 'lifestyle_b', schema_version: 1 };
      if (name === 'dw_home_product_click') {
        const id = link.dataset.dwProductId || '';
        const handle = link.dataset.dwProductHandle || '';
        if (!/^\d+$/.test(id) || !/^[a-z0-9-]+$/.test(handle)) return;
        payload.product_id = id;
        payload.product_handle = handle;
      }
      // Existing pixel subscribers may consume these custom events. Navigation never waits.
      const result = shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {
      // Missing/blocked analytics must never interfere with a purchase journey.
    }
  });
})();
